import { LOANREQUEST_BUCKETS } from 'cpool-constants';
import type { LOANREQUEST_BUCKET } from 'cpool-constants';

export const isAssignedIKClearingLead = ({ type, userIds }: { type: LOANREQUEST_BUCKET | null; userIds: string[] }) =>
    type === LOANREQUEST_BUCKETS.IK_CLEARING && userIds.length > 0;
